import React from "react";
import { Box, Paper, Typography, Divider, Stack } from "@mui/material";
import moment from "moment-timezone";
import {Actions} from "../../../redux/Actions/Actions";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";

const PastBetCard = ({ teamData }) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const gotoHome = () => {
      dispatch({
        type: Actions.TEST_CASE,
        data: false,
      });
      navigate("/");
    };

  return (
    <Box padding={3}>
      {teamData?.map((bet, index) => (
        <Paper
          key={index}
          elevation={3}
          sx={{ bgcolor: "#f6f6f6", borderRadius: 2, p: 2, mb: 3 }}
        >
          {/* Header Bar */}
          <Box
            sx={{
              bgcolor: "#1976d2",
              color: "#fff",
              px: 2,
              py: 1,
              borderRadius: 1,
              fontWeight: 600,
              mb: 2,
            }}
          >
            BET ID : {bet._id}
          </Box>

          {/* Contest Info */}
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="subtitle1" fontWeight={600}>
              {bet.eventName} { " "}({moment(bet.eventDate).format("ddd, MMM D, h:mm A")})
            </Typography>
          </Box>

          <Typography variant="body2" sx={{ mb: 1, mt: 1 }}>
            Contest Entry Fee: <strong>${bet.poolPrice.toFixed(2)}</strong>
          </Typography>
          <Typography variant="h6" sx={{ color: "green", fontWeight: "bold" }}>
            Rank : {bet?.rank}
            {/* {" "}{"(30 Pts)"} */}
          </Typography>

          <Divider sx={{ my: 2 }} />

          {/* Players */}
          {bet.players.map((player, i) => (
            <Box key={i} mb={2}>
              <Typography
                variant="body1"
                fontWeight={600}
                color={player.isError ? "error" : "text.primary"}
                sx={{ mt: 1, mb: 1 }}
              >
                {player.name} {`(${player?.finalpoints} Points)`}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {player?.positionAbv} | {player?.teamName}
                {/* <strong>{player.prediction}</strong> */}
              </Typography>
            </Box>
          ))}

          <Divider sx={{ my: 2 }} />

          {/* Status */}
          <Typography variant="body2" fontWeight={600} color="primary">
            Status: {bet?.status ? bet?.status : "Active"}
          </Typography>
        </Paper>
      ))}

      {teamData.length === 0 && (
                        <div className="col-md-12">
                          <div className="null-entries">
                            <p>No Entries placed yet !</p>
                            <button
                              className="btn-primary mt-2 btn save-btn placebetbtn"
                              onClick={gotoHome}
                            >
                              PLACE BET
                            </button>
                          </div>
                        </div>
                      )}
    </Box>
  );
};

export default PastBetCard;
